module.exports = __webpack_public_path__ + "img/empty.60d908aa.png";